import React from 'react';

import CsvImportModal from '~/components/CsvImportModal/CsvImportModal';
import { importResidents, ImportResidentResult } from '~/api/resident';

type Props = {
  buildingId: string;
  buildingName?: string;
  onClose: (createdAny: boolean) => void;
};

const ImportResidentsModal = ({ buildingId, buildingName, onClose }: Props) => (
  <CsvImportModal<ImportResidentResult>
    title={`Create Residents using CSV${
      buildingName ? ` in ${buildingName}` : ''
    }`}
    intro="Unit is optional. Each resident's password will be their phone number, digits only. No welcome email or text is sent."
    requiredColumns={['first_name', 'last_name', 'email', 'phone']}
    templateColumns={['first_name', 'last_name', 'email', 'phone', 'unit']}
    templateRow='Jane,Doe,jane.doe@example.com,2517161299,1-104'
    templateFilename='cobu-residents-template.csv'
    resultsFilename={`resident-import-results-${
      buildingName || buildingId
    }.csv`}
    columns={[
      { header: 'first_name', value: (r) => r.firstName },
      { header: 'last_name', value: (r) => r.lastName },
      { header: 'email', value: (r) => r.email },
      { header: 'phone', value: (r) => r.phone },
      { header: 'unit', value: (r) => r.unit }
    ]}
    importRows={(rows, dryRun) => importResidents(buildingId, rows, dryRun)}
    onClose={onClose}
  />
);

export default ImportResidentsModal;
